import { getSupportContent } from "../api/dataFactory";

const supportContentMixin = subject => ({
  data() {
    return {
      supportContent: ""
    };
  },

  created() {
    this.initData();
  },

  methods: {
    async initData() {
      this.$emit("onContentDownloading", true);

      let backendResponse = await getSupportContent(subject);
      if (backendResponse) {
        this.supportContent = backendResponse.content;
      }

      this.$emit("onContentDownloaded", false);
    }
  }
});

export default supportContentMixin;
